import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { displayDate } from "./displayDate";
import { momentLocaleFor } from "./i18nFormatters";

// Wraps `displayDate` so React components don't have to repeat the
// `useTranslation` + `momentLocaleFor` boilerplate at every call site.
// Non-React callers (utility functions, the i18n formatter) should keep
// using `displayDate(value, locale)` directly.
export const useDisplayDate = () => {
  const { i18n } = useTranslation();
  const locale = momentLocaleFor(i18n.language);
  return useCallback((value: string) => displayDate(value, locale), [locale]);
};
